<template>
  <question-item
    :question="question"
    :operates="['copy','remove']"
    :more-operates="[]"
    :seniors="['source', 'editor', 'image']"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import QuestionItem from '@/question/components/QuestionItem'
import { createControlQuestion } from '@/api/control-lib'

export default {
  name: 'ControlQuestion',
  props: {
    question: {
      type: Object,
      default: () => ({})
    }
  },
  components: { QuestionItem },
  created() {
    if (!this.question.id) {
      const uw = this.$watch('question.issue.correct_answer', val => {
        if (!val.length) {
          return
        }
        createControlQuestion(this.question.getParams()).then(res => {
          this.question.id = res.data.data
          this.$emit('success')
          this.$message.success('添加成功')
        })
        uw()
      })
    }
  }
}
</script>
